import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { environment } from "@environments/environment";
import { RequestHelper } from "@helper/request.helper";
import { MessageConstant } from '@constant/message.constant';
import { Router } from '@angular/router';
import { NavigationConstant } from '@constant/navigation.constant';
import { BncStorage } from "@shared/storage/bnc.storage";


@Component({
    selector: 'app-payment-bnc',
    templateUrl: './payment.bnc.component.html',
    styleUrls: ['./payment.bnc.component.css']
})
export class PaymentBNCComponent implements OnInit{

    customerName:string;
    virtualAccount:string;
    numberAccount:string;
    amount:string;
    billingType:string;
    billingNumber:string;
    txtAmount:string;
    billingTypeDescription: string
    constructor(private http: HttpClient, private apiService:RequestHelper, private router: Router, private storage: BncStorage){}

    ngOnInit() {
        console.log("payment bnc..");
        var responsePayment = localStorage.getItem('bnc_result_inquiry');
        console.log('data from localstorage -> '+responsePayment);
        let jsonResponsePayment = JSON.parse(responsePayment);
        this.customerName = jsonResponsePayment.customer_name;
        this.virtualAccount = jsonResponsePayment.virtual_account;
        this.amount = jsonResponsePayment.trx_amount;
        this.billingType = jsonResponsePayment.billing_type;
        this.numberAccount = jsonResponsePayment.trx_id;
        this.billingTypeDescription = jsonResponsePayment.billing_type_description;
        console.log("data customer name -> "+this.customerName);
    }

    submitPayment(){
        console.log("submit payment processing..");

        if (this.txtAmount == null || this.txtAmount.toString().length > 15) {
            this.openDialog(MessageConstant.PAYMENT_FAILED);
        }

        console.log("call notif payment..");
        const requestPaymentNotificationInquiry = {
            "virtual_account": this.virtualAccount,
            "amount": this.txtAmount,
        }
        console.log("data request -> "+JSON.stringify(requestPaymentNotificationInquiry));
        this.http.post(environment.apiUrl+'bnc/payment-notification', requestPaymentNotificationInquiry)
            .subscribe(response => {
                console.log("data after response success -> "+JSON.stringify(response));
                var data = JSON.parse(JSON.stringify(response));
                console.log("response message : "+data.message);
                console.log("response status : "+data.status);
                this.doValidateMessage(data);
                this.storage.data = data;
                if(data.status === "00"){
                    const resultSuccessNotification = {
                        "virtual_account": this.virtualAccount,
                        "amount": this.txtAmount,
                        "customer_name": this.customerName,
                        "billing_number": null
                    }
                    localStorage.setItem('bnc_result_notification_success', JSON.stringify(resultSuccessNotification));
                    this.router.navigate([NavigationConstant.BNC_PAYMENT_RESULT])
                }
            }, error => console.log("error "+error));

    }

    openDialog(result) {
        this.apiService.openDialog(result, "bnc/payment");
    }

    doValidateMessage(data:any){
        if (data.status == "00"){
            console.log("success");
        }
        if (data.status == "003"){
            this.openDialog(MessageConstant.ALREADY_PAID);
        }
        if (data.status == "01"){
            this.openDialog(data.message);
        }
        if (data.status == "02"){
            this.openDialog(data.message);
        }
        if (data.status == "099"){
            this.openDialog(data.message);
        }
    }

    goHome() {
        this.router.navigate([NavigationConstant.HOME]);
    }
}